import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry, MatSnackBar } from '@angular/material';
import { AppSettings } from '../../app.constant';
import { OrganisationService } from '../../shared/services/organisation.service';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.css'],
  animations: [
    trigger('popOverState', [
      state('show', style({
        opacity: 1,
      })),
      state('hide', style({
        opacity: 0,
        display: 'none'
      })),
      transition('show => hide', animate('600ms ease-out')),
      transition('hide => show', animate('1000ms ease-in'))
    ]),

    trigger('popOverTable', [
      state('hide', style({
        opacity: 0,
        display: 'none'
      })),
      state('show', style({
        opacity: 1
      })),
      transition('hide => show', animate('600ms ease-out')),
      transition('show => hide', animate('1000ms ease-in'))
    ])
  ]
})

export class OrganisationComponent implements OnInit {
  httpResponseMessage: any;
  PK_OrganisationID: any = '';
  OrganisationCode: any = '';
  OrganisationName: string = '';
  Logo: string = '';
  City: string = '';
  Country: string = '';
  Address: string = '';
  Telephone: string = '';
  Fax: string = '';
  Email: string = '';
  Website: string = '';
  FK_Position: number;
  Head_of_Institution: string = '';
  Head_of_Institution_Signature: string = '';
  RegistrationNo: string = '';
  organisationForm: FormGroup;
  submitted = false;
  post: any;
  positions: any;
  Organisationentity: any;
  errorMessage: String;
  imageurl: string = "assets/images/pattern-01.png";
  // fileToUpload: File = null;
  selectedFile: File = null;
  show = true;
  tableShow = false;
  buttonTitle: String = 'S A V E ';
  newtitle: String = " N E W ";

  constructor(
    public dialog: MatDialog,
    private FormBuilder: FormBuilder,
    private _organisationservice: OrganisationService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private snackBar: MatSnackBar) {
    iconRegistry.addSvgIcon(
      'thumbs-up',
      sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/left-arrow.svg'));
  }

  ngOnInit() {

    this.organisationForm = this.FormBuilder.group({
      'PK_OrganisationID': ['',],
      'OrganisationCode': ['', [Validators.required, Validators.maxLength(20)]],
      'OrganisationName': ['', [Validators.required, Validators.maxLength(250)]],
      'RegistrationNo': ['', [Validators.required, Validators.maxLength(20)]],
      'Address': ['', Validators.required],
      'Logo': ['',],
      'City': ['', Validators.required],
      'Country': ['', Validators.required],
      'Telephone': ['', Validators.required],
      'Fax': ['', Validators.required],
      'Email': ['', Validators.required],
      'Website': ['', Validators.required],
      'Head_of_Institution': ['', Validators.required],
      'FK_Position': [''],
      'Head_of_Institution_Signature': ['', Validators.required],
      'FileUpload1': ['', Validators.required],
    })
    this.getAllPosition();
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    this.organisationForm.get('FileUpload1').setValue(this.selectedFile);
    this.organisationForm.get('Head_of_Institution_Signature').setValue(this.selectedFile);
  }

  // handleFileInput(files: FileList) {
  //   this.fileToUpload = files.item(0);
  //   var reader =new FileReader();
  //   reader.onload=(event:any)=>{
  //     this.imageurl = event.target.result;
  //   }
  //   reader.readAsDataURL(this.fileToUpload);
  // }

  public hasError = (controlName: string, errorName: string) => {
    return this.organisationForm.controls[controlName].hasError(errorName);
  }

  postOrganisation(post): void {
    if (post.PK_OrganisationID != '' && post.PK_OrganisationID != null) {
      this.updateOrganisation(post);
    }
    else {
      this.createOrganisation(post);
    }
  }

  get stateName() {
    return this.show ? 'show' : 'hide'
  }


  get tableToggleName() {
    return this.tableShow ? 'hide' : 'show'
  }
  cleardata() {
    this.organisationForm.reset();
  }

  updateOrganisation(post) {
    if (this.organisationForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._organisationservice.updateOrganisation(AppSettings.API_ENDPOINT + AppSettings.UpdateOrganisation, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.organisationForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  createOrganisation(post): void {
    this.submitted = true;
    if (this.organisationForm.invalid) {
      return;
    }
    const formdata = new FormData();
    formdata.append('PK_OrganisationID', this.organisationForm.get('PK_OrganisationID').value);
    formdata.append('OrganisationCode', this.organisationForm.get('OrganisationCode').value);
    formdata.append('OrganisationName', this.organisationForm.get('OrganisationName').value);
    formdata.append('RegistrationNo', this.organisationForm.get('RegistrationNo').value);
    formdata.append('Address', this.organisationForm.get('Address').value);
    formdata.append('City', this.organisationForm.get('City').value);
    formdata.append('Country', this.organisationForm.get('Country').value);
    formdata.append('Telephone', this.organisationForm.get('Telephone').value);
    formdata.append('Fax', this.organisationForm.get('Fax').value);
    formdata.append('Email', this.organisationForm.get('Email').value);
    formdata.append('Website', this.organisationForm.get('Website').value);
    formdata.append('Head_of_Institution', this.organisationForm.get('Head_of_Institution').value);
    formdata.append('FK_Position', this.organisationForm.get('FK_Position').value);
    formdata.append('FileUpload1', this.organisationForm.get('FileUpload1').value);
    formdata.append('Head_of_Institution_Signature', this.organisationForm.get('Head_of_Institution_Signature').value);

    this._organisationservice.postOrganisation(AppSettings.API_ENDPOINT + AppSettings.CreateOrganisation, formdata).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.organisationForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  receiveData($event) {
    this.Organisationentity = $event
    this.OrganisationName = (this.Organisationentity[0].OrganisationName).trim();
    this.OrganisationCode = (this.Organisationentity[0].OrganisationCode).trim();
    this.PK_OrganisationID = this.Organisationentity[0].PK_OrganisationID;
    this.Address = (this.Organisationentity[0].Address).trim();
    this.RegistrationNo = this.Organisationentity[0].RegistrationNo;
    this.City = (this.Organisationentity[0].City).trim();
    this.Country = (this.Organisationentity[0].Country).trim();
    this.Telephone = (this.Organisationentity[0].Telephone).trim();
    this.Fax = (this.Organisationentity[0].Fax).trim();
    this.Email = (this.Organisationentity[0].Email).trim();
    this.Website = (this.Organisationentity[0].Website).trim();
    this.Head_of_Institution = (this.Organisationentity[0].Head_of_Institution).trim();
    this.FK_Position = this.Organisationentity[0].FK_Position;
  }

  getAllPosition(): void {
    this._organisationservice.getAllPosition(AppSettings.API_ENDPOINT + AppSettings.GetAllPosition).subscribe(
      data => {
        this.positions = data;

      },
      error => this.errorMessage = <any>error)
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}
